module.exports = __webpack_public_path__ + "img/logout.e6b7707f.svg";